
import { Button } from "@/components/ui/button";
import Navbar from "@/components/Navbar";
import { Link } from "react-router-dom";
import { CheckCircle } from "lucide-react";

const ThankYou = () => {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <div className="container mx-auto px-4 pt-32 pb-16 flex flex-col items-center justify-center text-white">
        <div className="max-w-2xl w-full bg-black/40 backdrop-blur-md rounded-lg p-8 flex flex-col items-center">
          <CheckCircle className="h-20 w-20 text-[#FF3366] mb-6" />
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-4">
            Awesome.... Thank you for joining!
          </h1>
          <p className="text-xl text-center text-gray-300 mb-8">
            You're now on the waitlist to learn how to capture volatility & earn with gridbots.
          </p>
          <p className="text-center text-gray-300 mb-6">
            Check your inbox soon for exclusive updates and early access information.
          </p>
          <Link to="/">
            <Button className="bg-[#FF3366] hover:bg-[#E62E5C] text-white px-6 py-2">
              Back to Home
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ThankYou;
